// extracted by mini-css-extract-plugin
module.exports = {"sammelanfrageFooter":"SammelanfrageFooter_sammelanfrageFooter__UWoKJ"};